import { render, staticRenderFns } from "./RaceInformationSection.vue?vue&type=template&id=5e63df94&scoped=true"
import script from "./RaceInformationSection.vue?vue&type=script&lang=ts"
export * from "./RaceInformationSection.vue?vue&type=script&lang=ts"
import style0 from "./RaceInformationSection.vue?vue&type=style&index=0&id=5e63df94&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e63df94",
  null
  
)

export default component.exports